var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"text"},[_vm._v(" "+_vm._s(_vm.labels.temp.footerText)+" ")]),_c('img',{staticClass:"image",attrs:{"src":require("@/assets/icons/zoll-ak-logo.png")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }